import createReducer from 'common/redux/utils/createReducer';
import { List } from 'immutable';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';
import { UPDATE_SCORE } from 'funnel/actions/score';

const getInitialState = {
  items: List(),
};

const scores = createReducer(getInitialState, {
  [RECEIVE_FUNNEL](state, { funnel }) {
    const { decision_grid: grid } = funnel;

    return {
      ...state,
      items: List(grid),
    };
  },
  [UPDATE_SCORE](state, { product, answer, score }) {
    const itemEqual = i => i.product === product && i.answer === answer;

    let items;
    if (state.items.some(itemEqual)) {
      items = state.items.map(i => {
        if (i.product === product && i.answer === answer) {
          return {
            ...i,
            score,
          };
        }

        return i;
      });
    } else {
      items = state.items.push({
        product,
        answer,
        score,
      });
    }

    return {
      ...state,
      items,
    };
  },
});

export default scores;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/scores.js